import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import logo3dmu from "../assets/images/3dmuLogo.png";
import "./LoginPage.css";

const LoginPage = ({ setIsLoggedIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await fetch("/enc.txt"); // file in public folder
      const encryptedText = await response.text();

      const key = "testing_models_donot_delete_or_change";
      const bytes = CryptoJS.AES.decrypt(encryptedText, key);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
      const users = JSON.parse(decryptedText);

      const valid = users.some(user => {
        const userEmail = Object.keys(user)[0];
        const userPassword = user[userEmail];
        return userEmail === email && userPassword === password;
      });

      if (valid) {
        sessionStorage.setItem("LogInState", "true");
        sessionStorage.setItem("userEmail", email);
        setIsLoggedIn(true); // <-- This triggers re-render with new login state
        navigate("/dashboard", { state: { email } });
      } else {
        sessionStorage.setItem("LogInState", "false");
        setIsLoggedIn(false);
        alert("Invalid email or password.");
      }
    } catch (error) {
      console.error("Error reading enc.txt:", error);
      alert("Login failed. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <header>
        <img src={logo3dmu} alt="Logo" height="120px" />
      </header>
      <div className="login-form">
        <h2>Customer Dashboard</h2>
        <form>
          <div>
            <label>Email:</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          <div>
            <label>Password:</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          <button type="button" onClick={handleLogin}>Login</button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
